module.exports = __webpack_public_path__ + "media/images/kyle-ewing-fd22c72b9cbe54b36de562b287c9d8ec.jpeg";